// Called when form is submitted
import { db } from "./firebaseConfig";
import { doc, setDoc, updateDoc, serverTimestamp, Timestamp } from "firebase/firestore";

// Called when form is submitted for each item
export const addOrder = async (orderData) => {
  try {
    const orderID = orderData.orderID;
    const qrGeneratedDate = new Date();
    const qrExpireDate = new Date(qrGeneratedDate);
    qrExpireDate.setDate(qrGeneratedDate.getDate() + 30);

    const orderDetails = {
      orderID,
      stripePaymentIntentID: orderData.stripePaymentIntentID || "",
      orderDate: serverTimestamp(),
      qrGeneratedDate: Timestamp.fromDate(qrGeneratedDate),
      qrExpireDate: Timestamp.fromDate(qrExpireDate),
      sendCardOn: null, // Placeholder for future scheduled email send
      customerName: orderData.customerName,
      customerEmail: orderData.customerEmail,
      recipientName: orderData.recipientName,
      recipientEmail: orderData.recipientEmail || null,
      recipientVideo: orderData.recipientVideo || null,
      codeName: orderData.codeName,
      itemName: orderData.itemName,
      itemCategory: orderData.itemCategory,
      itemDescription: orderData.itemDescription,
      qrCodeFilename: `${orderID}.png`,
      pdfFilename: `${orderID}.pdf`
    };

    await setDoc(doc(db, "orders", orderID), orderDetails);
    console.log("Order successfully written with ID:", orderID);
    return orderID;
  } catch (error) {
    console.error("Error saving order:", error);
    return null;
  }
};


// Called *after* QR image is uploaded to Firebase Storage
export const updateOrderWithQR = async (orderID, qrImageUrl) => {
  try {
    const docRef = doc(db, "orders", orderID);
    await updateDoc(docRef, {
      qrImageUrl: qrImageUrl,
    });
    console.log("QR Image URL saved to Firestore.");
  } catch (error) {
    console.error("Error updating order with QR image URL:", error);
  }
};